import {
  GET_CMS_SUCURSALES,
  GET_CMS_CONVENIOS,
  CALCULAR_CREDITO,
  CALCULAR_CREDITO_ERROR,
  GET_ALL_CREDITOS,
  GET_ALL_CREDITOS_ERROR,
  GET_CMS_AFILIACION,
  GET_CMS_ORGANIZACION,
  GET_CMS_ORGANIZACION_ERROR,
  GET_CMS_INFO_CREDITOS_PERSONALES,
  GET_CMS_INFO_CREDITOS_HIPOTECARIOS,
  GET_CMS_INFO_AHORROS_PROGRAMADOS,
  GET_ALL_SERVIAHORRO,
  GET_ALL_SERVIAHORRO_ERROR,
  GET_CMS_INVERSIONES,
  GET_CMS_HISTORIA,
  GET_CMS_HISTORIA_ERROR,
  GET_CMS_DELEGADOS,
  GET_CMS_PLANES_ASISTENCIA,
  GET_CMS_PLANES_ASISTENCIA_ERROR,
  GET_CMS_TARJETAS,
  GET_CMS_TARJETAS_ERROR,
  GET_CMS_BIENES_BANNER,
  GET_CMS_BIENES_BANNER_ERROR,
  GET_CMS_INFO_CREDITOS_PRODUCTIVOS,
  GET_CMS_TIPS_SEGURIDAD,
  GET_CMS_TIPS_SEGURIDAD_ERROR,
  GET_CMS_FIRMA_DIGITAL,
  GET_CMS_FIRMA_DIGITAL_ERROR,
  GET_CMS_REGLAMENTOS,
  GET_CMS_REGLAMENTOS_ERROR,
  GET_CMS_PROMOCIONES,
  GET_CMS_PROMOCIONES_ERROR,
  GET_CMS_RESUME_BANNER,
  GET_CMS_RESUME_BANNER_ERROR,
  GET_CMS_COMUNICADOS,
  GET_CMS_COMUNICADOS_ERROR,
  GET_CMS_GESTION_PAGOS,
  GET_CMS_GESTION_PAGOS_ERROR
} from "./types";
import AhorroYCreditoService from "app/@Content/components/AhorroYCredito/services/ahorroycredito.service";

export function getCMSSucursales() {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSSucursales().then((data) => {
        dispatch({
          type: GET_CMS_SUCURSALES,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_SUCURSALES,
        payload: {},
      });
    }
  };
}

export function getCMSConvenios() {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSConvenios().then((data) => {
        dispatch({
          type: GET_CMS_CONVENIOS,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_CONVENIOS,
        payload: {},
      });
    }
  };
}

export function getHistoria() {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqHistoria().then((data) => {
        dispatch({
          type: GET_CMS_HISTORIA,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_HISTORIA_ERROR,
        });
      };
    }
  };
}

export function getCMSDelegados() {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSDelegados().then((data) => {
        dispatch({
          type: GET_CMS_DELEGADOS,
          payload: data,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_DELEGADOS,
          payload: {},
        });
      };
    }
  };
}

export function getCreditos() {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqAllCreditos().then((data) => {
        dispatch({
          type: GET_ALL_CREDITOS,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_ALL_CREDITOS_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getCalculoCredito(dataObj) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCalcularCredito(dataObj).then((data) => {
        dispatch({
          type: CALCULAR_CREDITO,
          payload: data,
        });
        return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: CALCULAR_CREDITO_ERROR,
          payload: error,
        });
        return error;
      };
    }
  };
}

export function getCMSAfiliacion(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSAfiliacion(token).then((data) => {
        dispatch({
          type: GET_CMS_AFILIACION,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_AFILIACION,
        payload: {},
      });
    }
  };
}

export function getOrganizacion(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqOrganizacion(token).then((data) => {
        dispatch({
          type: GET_CMS_ORGANIZACION,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_ORGANIZACION_ERROR,
        payload: {},
      });
    }
  };
}

export function getCreditosPersonales(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCreditosPersonales(token).then((data) => {
        dispatch({
          type: GET_CMS_INFO_CREDITOS_PERSONALES,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_INFO_CREDITOS_PERSONALES,
        payload: {},
      });
    }
  };
}

export function getCreditosHipotecarios(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCreditosHipotecarios(token).then(
        (data) => {
          dispatch({
            type: GET_CMS_INFO_CREDITOS_HIPOTECARIOS,
            payload: data,
          });
        }
      );
    } catch (error) {
      dispatch({
        type: GET_CMS_INFO_CREDITOS_HIPOTECARIOS,
        payload: {},
      });
    }
  };
}

export function getCreditosProductivos(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCreditosProductivos(token).then(
        (data) => {
          dispatch({
            type: GET_CMS_INFO_CREDITOS_PRODUCTIVOS,
            payload: data,
          });
        }
      );
    } catch (error) {
      dispatch({
        type: GET_CMS_INFO_CREDITOS_PRODUCTIVOS,
        payload: {},
      });
    }
  };
}

export function getAhorrosProgramados(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqAhorrosProgramados(token).then((data) => {
        dispatch({
          type: GET_CMS_INFO_AHORROS_PROGRAMADOS,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_INFO_AHORROS_PROGRAMADOS,
        payload: {},
      });
    }
  };
}

export function getServiahorro(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqServiahorro(token).then((data) => {
        dispatch({
          type: GET_ALL_SERVIAHORRO,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_ALL_SERVIAHORRO_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getCMSInversiones(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSInversiones(token).then((data) => {
        dispatch({
          type: GET_CMS_INVERSIONES,
          payload: data,
        });
      });
    } catch (error) {
      dispatch({
        type: GET_CMS_INVERSIONES,
        payload: {},
      });
    }
  };
}

export function getPlanesAsistencia(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqPlanesAsistencia(token).then((data) => {
        dispatch({
          type: GET_CMS_PLANES_ASISTENCIA,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_PLANES_ASISTENCIA_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getTarjetas(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqTarjetas(token).then((data) => {
        dispatch({
          type: GET_CMS_TARJETAS,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_TARJETAS_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getBienesBanner(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqCMSBienesBanner(token).then((data) => {
        dispatch({
          type: GET_CMS_BIENES_BANNER,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_BIENES_BANNER_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getTipsDeSeguridad(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqTipsDeSeguridad(token).then((data) => {
        dispatch({
          type: GET_CMS_TIPS_SEGURIDAD,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_TIPS_SEGURIDAD_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getFirmaDigital(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqFirmaDigital(token).then((data) => {
        dispatch({
          type: GET_CMS_FIRMA_DIGITAL,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_FIRMA_DIGITAL_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getReglamentos(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqReglamentos(token).then((data) => {
        dispatch({
          type: GET_CMS_REGLAMENTOS,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_REGLAMENTOS_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getPromociones(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqPromociones(token).then((data) => {
        dispatch({
          type: GET_CMS_PROMOCIONES,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_PROMOCIONES_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getResumeBanner(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqResumeBanner(token).then((data) => {
        dispatch({
          type: GET_CMS_RESUME_BANNER,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_RESUME_BANNER_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getComunicadosOficiales(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqComunicadosOficiales(token).then((data) => {
        dispatch({
          type: GET_CMS_COMUNICADOS,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_COMUNICADOS_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}

export function getGestionPagos(token) {
  return function (dispatch) {
    try {
      return AhorroYCreditoService.reqGestionPagos(token).then((data) => {
        dispatch({
          type: GET_CMS_GESTION_PAGOS,
          payload: data,
        });
        //return data;
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: GET_CMS_GESTION_PAGOS_ERROR,
          payload: error,
        });
        //return error;
      };
    }
  };
}